export const Yape = {
	name: 'Yape',
	code: 'yape',
};

export const Plin = {
	name: 'Plin',
	code: 'plin',
};

export default { Yape, Plin };



// WEBPACK FOOTER //
// ./src/shared/enums/depositPayment.js